<template>
  <div class="repair">
    <!-- <MainTopNav></MainTopNav> -->
    <CarChoose v-for="item in items" :key="item.id" :item="item" @call-func="getBrandNode($event)"></CarChoose>
    <div class="m-l-5 m-r-5 f-16 m-b-20">
      <van-button v-show="showButton" style="font-size:16px;" color="#45a4b6" @click="gotoList"
                  type="primary" block>确认查询
      </van-button>
    </div>
    <MainMenuNav/>
  </div>
</template>

<script>
import {
  Tab,
  Tabs,
  Image as VanImage,
  Lazyload,
  Grid,
  GridItem,
  Button,
} from "vant";
import MainTopNav from "@/components/MainTopNav.vue";
import MainMenuNav from "@/components/MainMenuNav.vue";
import CarChoose from "@/components/CarChoose.vue";
import {Get_Brand_Node} from "@/api/index";

export default {
  name: "Choose",
  components: {
    MainTopNav,
    MainMenuNav,
    CarChoose,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [VanImage.name]: VanImage,
    [Lazyload.name]: Lazyload,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Button.name]: Button,
  },
  data() {
    return {
      activeName: "a",
      items: [],
      selectValue: 0,
      item: {},
      showButton: false,
      company: {},
      hasCase: false
    };
  },
  methods: {

    async getBrandNode(obj) {
      this.selectValue = obj[0];
      if (this.items.some((item) => item.id == obj[0])) return;

      this.$set(obj[2], "showId", obj[0]);
      var type = this.$route.params.type;
      if (
          ((type == 0 || type == 2) && obj[2].level > 4) ||
          (type == 1 && obj[2].level > 5)
      ) {
        this.showButton = true;
        return;
      } else {
        this.showButton = false;
      }

      var index = this.items.findIndex((item) => item.id == obj[1]);
      if (index >= 0) this.items.splice(index + 1);

      var params = {
        id: obj[0],
        depth: 2,
        regionType: this.company.type,
      };
      this.items.push(await Get_Brand_Node(params));
    },
    gotoList() {
      const index = this.items.findIndex((item) => item.name == '案例大全');
      if (index >= 0) {
        this.$router.push({
          path: "/repair/caselist",
          query: {brandId: this.selectValue},
        });
      } else {
        this.$router.push({
          path: "/FileMenu/" + this.selectValue
        });
      }
    }
  },
  created() {
    // debugger;
    // this.getBrandNode([this.$route.params.pId, this.$route.params.pId, {}]);
  },
  async mounted() {
    this.company = await this.global.getMemberSystem();
    this.getBrandNode([this.$route.params.pId, this.$route.params.pId, {}]);
  },
  watch: {
    items: function (val, oldVal) {
      this.$nextTick(function () {
        document.body.scrollTop = 10000;
        document.documentElement.scrollTop = 10000;
      });
    },
  },
};
</script>
